import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cs from 'classnames';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { selectLaborClassificationName } from 'store/laborClassifications';
import formatNumber from '../../utils/formatNumber';
import hoursMinutesToNumber from '../../utils/hoursMinutesToNumber';
import { Field, Hours } from './Rows';
import styles from './styles';

const useStyles = makeStyles(styles);

const JobPrint = ({ data }) => {
  const classes = useStyles();
  const laborClassificationName = useSelector((state) =>
    selectLaborClassificationName(state, data?.laborClassificationId)
  );
  const { formatForTimePars } = useTimeSettingsFormat()();
  const { sheet, hours } = data;
  const { project, rainPay } = sheet;
  const onJob = hours?.start && hours?.end;

  const times = [
    onJob && [
      'On Job Time:',
      formatNumber(hours.hours),
      <span className={classes.nowrap}>
        {format(new Date(hours.start), formatForTimePars)} -{' '}
        {format(new Date(hours.end), formatForTimePars)}
      </span>,
    ],
    [
      'Travel Time To Job:',
      formatNumber(data.travelTo >= 0 ? data.travelTo : hoursMinutesToNumber(hours?.travelTimeTo)),
    ],
    [
      'Travel Time From Job:',
      formatNumber(
        data.travelFrom >= 0 ? data.travelFrom : hoursMinutesToNumber(hours?.travelTimeFrom)
      ),
    ],
    rainPay &&
      (+rainPay.hours > 0 || +rainPay.minutes > 0) && [
        'Misc. Stipend:',
        formatNumber(hoursMinutesToNumber(rainPay)),
      ],
  ];

  return (
    <div className={classes.job}>
      {project && (
        <>
          <div className={classes.jobName}>
            {project.contractor.name} - {project.route}
            {sheet.section ? ' - ' + sheet.section : null}
          </div>
          <div className={classes.info}>
            <div className={classes.fields}>
              <Field label="#">{project.jobNumber}</Field>
              <Field label="County:">{project.county}</Field>
              <Field label="State:">{project.state || 'N/A'}</Field>
            </div>
            <div className={classes.fields}>
              <Field label="Project type:">{project.type}</Field>
              <Field label="Certified Payroll:">{project.rated ? 'Yes' : 'No'}</Field>
            </div>
            <div className={cs(classes.fields, classes.group)}>
              <Field label="Labor Classification:">{laborClassificationName}</Field>
            </div>
            <div className={classes.fields}>
              <Field label="T&M:">{sheet.forceAccount}</Field>
              <Field label="EC:">{data.earningsCode || 'N/A'}</Field>
              <Field label="BR:">{data.baseRate ?? 'N/A'}</Field>
              <Field label="FB:">{data.fringeBenefit ?? 'N/A'}</Field>
            </div>
          </div>
        </>
      )}
      <div className={cs(classes.time, project && classes.beside)}>
        {times.filter(Boolean).map(([label, value, range]) => (
          <div key={label} className={classes.timeRow}>
            <Field label={label}>{range}</Field>
            <Hours value={value} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobPrint;
